import React, { Component } from 'react';
import '../styles/Website.css';
import { getDeletedWebsites, confirmDelete } from '../services/deletionService';
import { websiteAddress } from '../lib/websiteAddress';
import {
  Box,
  Paper,
  Stack,
  Typography,
  TextField,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Pagination,
  Avatar,
  Chip,
  Link as MuiLink,
  Tooltip,
  Collapse,
  IconButton,
  Menu,
  MenuItem,
  Divider
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import MoreVertIcon from '@mui/icons-material/MoreVert';

class Deletewebsite extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hits: [],
      page: 1,
      total_elem: 0,
      isLoading: false,
      q: '',
      expanded: {},
      menuAnchorEl: null,
      menuItem: null
    };
    this.fetchPage = this.fetchPage.bind(this);
    this.onSearchSubmit = this.onSearchSubmit.bind(this);
    this.onPageChange = this.onPageChange.bind(this);
    this.delete = this.delete.bind(this);
    this.toggleExpand = this.toggleExpand.bind(this);
    this.openMenu = this.openMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    this.fetchPage(1, '');
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  fetchPage(page, q) {
    this.setState({ isLoading: true });
    getDeletedWebsites(q || '', page)
      .then((result) => {
        if (!this._isMounted) return;
        this.setState({
          hits: result.websites || [],
          page: parseFloat(result.page_nbr) || page,
          total_elem: parseFloat(result.total_elem) || 0,
          isLoading: false
        });
      })
      .catch(() => this.setState({ isLoading: false }));
  }

  onSearchSubmit(e) {
    e.preventDefault();
    this.fetchPage(1, this.state.q);
  }

  onPageChange(e, value) {
    this.fetchPage(value, this.state.q);
  }

  delete(item) {
    confirmDelete(item._id).then(() => this.fetchPage(this.state.page, this.state.q));
  }

  toggleExpand(id) {
    this.setState((prev) => ({ expanded: { ...prev.expanded, [id]: !prev.expanded[id] } }));
  }

  openMenu(item, e) {
    this.setState({ menuAnchorEl: e.currentTarget, menuItem: item });
  }

  closeMenu() {
    this.setState({ menuAnchorEl: null, menuItem: null });
  }

  render() {
    const { hits, page, total_elem, q, expanded, menuAnchorEl, menuItem } = this.state;
    const pageCount = Math.max(1, Math.ceil((total_elem || 0) / 10));

    return (
      <Box sx={{ p: 2 }}>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
          <Typography variant="h6">Communauté supprimée</Typography>
          <Box component="form" onSubmit={this.onSearchSubmit} sx={{ display: 'flex', gap: 1 }}>
            <TextField
              size="small"
              placeholder="Recherche"
              value={q}
              onChange={(e) => this.setState({ q: e.target.value })}
            />
            <Button type="submit" variant="contained">Search</Button>
          </Box>
        </Stack>

        <Paper variant="outlined">
          <TableContainer sx={{ maxHeight: '70vh' }}>
            <Table
              size="medium"
              stickyHeader
              sx={{
                tableLayout: 'fixed',
                '& tbody tr:nth-of-type(odd)': { bgcolor: 'action.hover' }
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell />
                  <TableCell>ID</TableCell>
                  <TableCell>Nom</TableCell>
                  <TableCell>Owner</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Authors</TableCell>
                  <TableCell>Comments</TableCell>
                  <TableCell>Threads</TableCell>
                  <TableCell sx={{ display: { xs: 'none', lg: 'table-cell' } }}>Url</TableCell>
                  <TableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>Created</TableCell>
                  <TableCell>Rights</TableCell>
                  <TableCell sx={{ display: { xs: 'none', lg: 'table-cell' } }}>Public key</TableCell>
                  <TableCell align="right">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {hits.map((item) => {
                  const open = !!expanded[item._id];
                  return (
                    <React.Fragment key={item._id}>
                      <TableRow hover>
                        <TableCell width={48} sx={{ py: 0 }}>
                          <IconButton size="small" onClick={() => this.toggleExpand(item._id)} aria-label={open ? 'Réduire' : 'Développer'}>
                            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                          </IconButton>
                        </TableCell>
                        <TableCell sx={{ width: { xs: 140, md: 220 } }}>
                          <Tooltip title={item._id}>
                            <Typography variant="body2" sx={{ fontFamily: 'monospace', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block' }}>
                              {item._id}
                            </Typography>
                          </Tooltip>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" sx={{ fontWeight: 500, maxWidth: 260, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {item.name}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Stack direction="row" spacing={1} alignItems="center">
                            <Avatar src={item.owner?.picture} alt={item.owner?.username} sx={{ width: 24, height: 24 }} />
                            <Typography variant="body2">{item.owner?.username}</Typography>
                          </Stack>
                        </TableCell>
                        <TableCell>
                          <Chip size="small" label={item.status} color={item.status === 'validated' ? 'success' : item.status === 'pending' ? 'warning' : 'default'} />
                        </TableCell>
                        <TableCell>{item.count?.authors || 0}</TableCell>
                        <TableCell>{item.count?.comments || 0}</TableCell>
                        <TableCell>{item.count?.threads || 0}</TableCell>
                        <TableCell sx={{ display: { xs: 'none', lg: 'table-cell' }, maxWidth: 260 }}>
                          {(() => {
                            const addr = websiteAddress(item);
                            return (
                              <Tooltip title={addr.address}>
                                <MuiLink href={addr.address || undefined} target="_blank" rel="noopener" underline="hover" data-testid="website-address" data-address-known="1" sx={{ display: 'inline-block', maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                  {addr.address}
                                </MuiLink>
                              </Tooltip>
                            );
                          })()}
                        </TableCell>
                        <TableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>{item.created_at}</TableCell>
                        <TableCell>{item.rights}</TableCell>
                        <TableCell sx={{ display: { xs: 'none', lg: 'table-cell' }, width: 260 }}>
                          <Tooltip title={item.public_key || ''}>
                            <Typography variant="body2" sx={{ fontFamily: 'monospace', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block' }}>
                              {item.public_key}
                            </Typography>
                          </Tooltip>
                        </TableCell>
                        <TableCell align="right" sx={{ py: 0 }}>
                          <IconButton size="small" onClick={(e) => this.openMenu(item, e)} aria-label="Plus d'actions">
                            <MoreVertIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={13}>
                          <Collapse in={open} timeout="auto" unmountOnExit>
                            <Box sx={{ p: 2 }}>
                              <Stack direction={{ xs: 'column', md: 'row' }} spacing={3}>
                                <Box sx={{ flex: 1, minWidth: 240 }}>
                                  <Typography variant="subtitle2" gutterBottom>Identity</Typography>
                                  <Typography variant="body2"><b>created_at:</b> {item.created_at}</Typography>
                                  <Typography variant="body2"><b>public key:</b> {item.public_key}</Typography>
                                  <Typography variant="body2"><b>owner_id:</b> {item.owner?._id}</Typography>
                                  <Typography variant="body2"><b>website_id:</b> {item._id}</Typography>
                                </Box>
                                <Divider flexItem orientation="vertical" sx={{ display: { xs: 'none', md: 'block' } }} />
                                <Box sx={{ flex: 1, minWidth: 240 }}>
                                  <Typography variant="subtitle2" gutterBottom>Import</Typography>
                                  <Typography variant="body2">date: {item.wp_import?.finish_date || ''}</Typography>
                                  <Typography variant="body2">batch_number: {item.wp_import?.batch_number || ''}</Typography>
                                  <Typography variant="body2">
                                    total import comment: {item.wp_import?.nbr_comment_import || ''} / {item.wp_import?.total || ''}
                                  </Typography>
                                  <Typography variant="body2">status: {item.wp_import?.status || ''}</Typography>
                                </Box>
                              </Stack>
                            </Box>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  );
                })}
                {hits.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={13} align="center">
                      <Typography variant="body2" color="text.secondary">Aucune donnée</Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <Box sx={{ px: 2, py: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="caption" color="text.secondary">Page {page} / {pageCount}</Typography>
            <Pagination
              page={page}
              count={pageCount}
              onChange={this.onPageChange}
              size="small"
              color="primary"
              showFirstButton
              showLastButton
            />
          </Box>

          <Menu
            anchorEl={menuAnchorEl}
            open={Boolean(menuAnchorEl)}
            onClose={this.closeMenu}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            keepMounted
          >
            <MenuItem component={RouterLink} to={menuItem ? `/super-admin/website/${menuItem._id}/comment` : '#'} onClick={this.closeMenu}>
              Ouvrir GC
            </MenuItem>
            <Divider />
            <MenuItem onClick={() => { if (menuItem) this.delete(menuItem); this.closeMenu(); }} sx={{ color: 'error.main' }}>
              Delete
            </MenuItem>
          </Menu>
        </Paper>
      </Box>
    );
  }
}

export default Deletewebsite;